import React, { useEffect, useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { content } from '../data/content';
import { SunsetBands } from './SunsetBands';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-brand-cream shadow-md' : 'bg-transparent'}`} data-id="element-115">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-116">
        <div className="flex justify-between items-center h-[60px] md:h-20" data-id="element-117">
          {/* Logo / Wordmark */}
          <a href="#home" className="flex-shrink-0 flex items-center gap-2.5" data-id="element-118">
            <img src="https://cdn.magicpatterns.com/uploads/tKwUt9TmjKnTmLiRC8mb2e/hatch-painting-logo.jpg" alt="Hatch Painting logo" className="h-10 w-10 md:h-12 md:w-12 rounded-full object-cover" data-id="element-119" />
            <span className={`font-display font-bold text-xl tracking-wider ${isScrolled ? 'text-brand-brown' : 'text-brand-cream'}`} data-id="element-120">
              {content.company.wordmark}
            </span>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex space-x-8" data-id="element-121">
            {content.nav.map(item => <a key={item.label} href={item.href} className={`text-sm font-medium transition-colors hover:text-brand-orange ${isScrolled ? 'text-brand-brown' : 'text-brand-cream'}`} data-id="element-122">
                {item.label}
              </a>)}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center space-x-6" data-id="element-123">
            <a href={`tel:${content.company.phone.replace(/[^0-9]/g, '')}`} className={`flex items-center text-sm font-bold transition-colors hover:text-brand-orange ${isScrolled ? 'text-brand-brown' : 'text-brand-cream'}`} data-id="element-124">
              <Phone className="w-4 h-4 mr-2" data-id="element-125" />
              {content.company.phone}
            </a>
            <a href="#contact" className="bg-brand-orange text-brand-cream px-5 py-2.5 rounded font-medium hover:bg-opacity-90 transition-colors shadow-sm" data-id="element-126">
              Free Estimate
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="flex md:hidden items-center" data-id="element-127">
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className={`p-2 rounded-md ${isScrolled ? 'text-brand-brown' : 'text-brand-cream'}`} data-id="element-128">
              {isMobileMenuOpen ? <X className="h-6 w-6" data-id="element-129" /> : <Menu className="h-6 w-6" data-id="element-130" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && <div className="md:hidden bg-brand-cream border-t border-brand-tan/20 shadow-xl absolute w-full" data-id="element-131">
          <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-132">
            {content.nav.map(item => <a key={item.label} href={item.href} onClick={() => setIsMobileMenuOpen(false)} className="block px-3 py-3 text-base font-medium text-brand-brown hover:bg-brand-amber/10 hover:text-brand-orange rounded-md" data-id="element-133">
                {item.label}
              </a>)}
            <div className="mt-6 pt-6 border-t border-brand-tan/20 flex flex-col space-y-4 px-3" data-id="element-134">
              <a href={`tel:${content.company.phone.replace(/[^0-9]/g, '')}`} className="flex items-center justify-center text-brand-brown font-bold py-3 border-2 border-brand-brown rounded" data-id="element-135">
                <Phone className="w-5 h-5 mr-2" data-id="element-136" />
                Call {content.company.phone}
              </a>
              <a href="#contact" onClick={() => setIsMobileMenuOpen(false)} className="flex justify-center bg-brand-orange text-brand-cream px-4 py-3 rounded font-medium text-lg" data-id="element-137">
                Free Estimate
              </a>
            </div>
          </div>
        </div>}

      {/* Sunset underline when scrolled */}
      <div className={`transition-opacity duration-300 ${isScrolled ? 'opacity-100' : 'opacity-0'}`} data-id="element-138">
        <SunsetBands heights={['h-0.5', 'h-0.5', 'h-0.5', 'h-0.5']} data-id="element-139" />
      </div>
    </header>;
}